import { Routes, RouterModule } from "@angular/router";
import { DictionariesComponent } from "./dictionaries.component";

const routes: Routes = [
    { path: '', component: DictionariesComponent}
  ];

  export const dictionariesRouting = RouterModule.forChild(routes);
